import "./UserHeader.scss";
import {Role} from "../../models/Role";

interface UserHeaderProps {
    profileImage?: string;
    name: string;
    role?: Role;
};

export const UserHeader = (p: UserHeaderProps) => {
    const { profileImage, name, role  } = p;

    return (
        <div className="user-header-container">
            <div className="user-header-profile-image">
                {
                    profileImage === '' || profileImage === undefined
                    ?
                    <span className="user-header-icon"><i className='bi bi-person' style={{fontSize: 22}} /></span>
                    :
                    <div className="user-header-image">
                        <img
                            id="userHeaderImage"
                            src={profileImage}
                            alt="Profilna slika" />
                    </div>
                }
            </div>
            <div className="user-header-data">
                <div className="user-header-name">{name}</div>
                <div className="user-header-role">{role?.name}</div>
            </div>
        </div>
    );
};
